import { css } from 'styled-components';
import * as fonts from './fontfaces';
var declareFont = function declareFont(font) {
  return css(["@font-face{font-family:", ";font-display:swap;src:url(", ") format(", ");font-display:swap;}"], font, fonts[font], fonts[font].endsWith('.ttf') ? 'truetype' : 'woff2');
};
export default css(["", ""], function (props) {
  var _props$theme;
  return (_props$theme = props.theme) === null || _props$theme === void 0 ? void 0 : _props$theme.fonts.map(declareFont);
});